<template>
  <div id="colloquia-seminars-detail-tab-id" class="pt-dtl-tab-bg">
    <div>
      <b-card no-body class="custom-tab mb-4">
        <b-tabs card lazy>
          <b-tab
            title="Overview"
            @click.prevent="setDetailCurrentTab('overview_colloquia_seminars', 'colloquia-seminars-detail-tab-id', datas.abstract)"
            :active="getDetailActiveTab === 'overview_colloquia_seminars'"
          >
            <overview-tab-section :data="datas" />
          </b-tab>
          <b-tab
            title="Schedule & Notes"
            @click.prevent="setDetailCurrentTab('schedule_notes','colloquia-seminars-detail-tab-id')"
            :active="getDetailActiveTab === 'schedule_notes'"
          >
            <colloquia-seminar-schedule-and-notes-tab-section />
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import OverviewTabSection from "./OverviewTabSection.vue"
import mixin from "@/utils/mixin.js"
import { mapGetters } from "vuex"
import ColloquiaSeminarScheduleAndNotesTabSection from "./ColloquiaSeminarScheduleAndNotesTabSection.vue"

export default {
	components: { OverviewTabSection, ColloquiaSeminarScheduleAndNotesTabSection },
	name: "ColloquiaSeminarsTabsSection",
	props: ["datas"],
	mixins: [mixin],
	data() {
		return {
			tabs: ["#overview_colloquia_seminars", "#schedule_notes"],
		}
	},
	mounted() {
		if (this.tabs.indexOf(this.$route.hash) !== -1) {
			const hashPath = this.$route.hash
			this.setDetailCurrentTab(hashPath.substring(1), "colloquia-seminars-detail-tab-id")
		}
	},
	computed: {
		...mapGetters(["getDetailActiveTab"]),
	},
}
</script>
